import { Tabs, TabsList, TabsTrigger, TabsContent } from '@/components/ui/tabs';
import { FederalTab } from './federal/FederalTab';
import { SefazTab } from './sefaz/SefazTab';

export function ParametrosFiscalTab() {
  return (
    <TabsContent value="parametros-fiscal" className="space-y-4">
      <Tabs defaultValue="federal" className="space-y-4">
        <TabsList className="h-10">
          <TabsTrigger value="federal" className="px-6">
            FEDERAL
          </TabsTrigger>
          <TabsTrigger value="sefaz" className="px-6">
            SEFAZ
          </TabsTrigger>
        </TabsList>

        <TabsContent value="federal">
          <FederalTab />
        </TabsContent>

        <TabsContent value="sefaz">
          <SefazTab />
        </TabsContent>
      </Tabs>
    </TabsContent>
  );
}
